import "./css/general/fonts.css"
import "./css/general/variables.css"
import "./css/general/util.css"
import "./css/general/typography.css"
import "./css/general/layout.css"
import "./css/general/accessability.css"

import "./css/components/animations.css"
import "./css/components/icons.css"
import "./css/components/button.css"
import "./css/components/emergency.css"
import "./css/components/form.css"
import "./css/components/step.css"
import "./css/components/modal.css"
import "./css/components/checkboxes.css"
import "./css/components/contents.css"
import "./css/components/loading.css"
import "./css/components/nav.css"
import "./css/components/help.css"
import "./css/components/message.css"
import "./css/components/download.css"
import "./css/components/summary.css"
import "./css/components/custom-select.css"

import { render } from "preact"
import { Form } from "./js/components/form"
import { Menu } from "./js/components/menu"
import { qs } from "./js/util/dom"
import { Endpoint } from "./js/util/endpoint"

document.addEventListener(
  "DOMContentLoaded",
  () => {
    // menu
    const menuEl = qs("#menu")
    if (menuEl)
      render(
        <Menu
          ep={new Endpoint(menuEl.dataset.endpoint)}
          contactEp={new Endpoint(menuEl.dataset.contactEndpoint)}
        />,
        menuEl,
      )

    // main app
    const appEl = qs("#app-root")
    if (appEl) render(<Form ep={new Endpoint(appEl.dataset.endpoint)} />, appEl)

    const loadingscreen = document.querySelector(".loading-screen")
    if (loadingscreen) {
      setTimeout(() => {
        loadingscreen.classList.add("collapse")
        // setTimeout(() => {
        //   loadingscreen.classList.add("clicked")
        // }, 2000)
      }, 800)
    }
    // const loadingScreenButton = qs(".loading-screen__button button")
    // if (loadingScreenButton) {
    //   loadingScreenButton.addEventListener("click", () => {
    //     loadingScreenButton.closest(".loading-screen").classList.add("collapse")
    //     setTimeout(() => {
    //       loadingScreenButton
    //         .closest(".loading-screen")
    //         .classList.add("clicked")
    //     }, 2000)
    //   })
    // }
  },
  false,
)
